import layout from './layouts/';

window.daisy = layout;


// WEBPACK FOOTER //
// ./index.js